import React, { useEffect, useState } from "react";
import useButtonStyles from "../../styles/useButtonStyles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useAppSelector } from "../../redux/hooks";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { getEncodedValue } from "../forms/utility";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import formatDate from "../../util/dateFormat";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { constant } from "../../constants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import {
  DateConstants,
  SearchToolTip,
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}

const EvoucherTabNew = () => {
  const { getUserPermission: getEVoucherPermissions } = usePermissionGetter(
    constant.domain === process.env.REACT_APP_CSA_DOMAIN
      ? permissionsConstants.member_redemption
      : permissionsConstants.members,
    permissionsConstants.evouchers
  );
  const columns: TableColumn[] = [
    { key: "serialNo", header: "Serial Number" },
    { key: "title", header: "Title" },
    { key: "issuedOn", header: "Issuance Date" },
    { key: "orderId", header: "Order ID" },
    { key: "rewardValue", header: "Reward Value" },
    { key: "expiryDate", header: "Expiry Date" },
    { key: "sourceOfVouchers", header: "Source of Voucher" },
    { key: "redemptionDate", header: "Utilization Date" },
    { key: "merchantName", header: "Merchant Name" },
    { key: "id", header: "Transaction ID" },
    { key: "status", header: "Status" },
  ];
  const MemberRedemptionColumn: TableColumn[] = [
    { key: "voucherImage", header: "Image" },
    { key: "title", header: "Title" },
    { key: "serialNo", header: "Serial Number" },
    { key: "issuedOn", header: "Redemption Date" },
    { key: "rewardValue", header: "Amount" },
    { key: "pointSpend", header: "Point spend" },
    { key: "expiryDate", header: "Expiry Date" },
    { key: "sourceOfVouchers", header: "Source of Voucher" },
  ];
  const metaData = {
    voucherImage: {
      isImage: true,
      linkTo: "",
    },
  };
  const [openFilter, setOpenFilter] = useState(false);
  const [openPoints, setOpenPoints] = useState(false);

  const buttonStyles = useButtonStyles();

  const handleClose = () => {
    setOpenFilter(false);
  };

  const { totalCount, getTotalCounts, getTotalRecordsCount } =
    useGetTotalRecords();
  const [isInitialApiCall, setIsInitialApiCall] = useState(true);
  // integration
  const [loading, setLoading] = useState<boolean>(false);
  const [redeemVoucherData, setRedeemVoucherData] = useState([]);
  const [filterActive, setFilterActive] = useState(false);
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList.membersList
  );

  const [listOFSourceOfVoucher, setListOfSourceVoucher] = useState<any>([]);
  const fetchRewards = async (
    urlString?: string,
    canHaveExistingData?: boolean
  ) => {
    let queryParams = `?email=${memberDetails.email}`;
    let currentURl = `${
      process.env.REACT_APP_API_URL + APIConstants.getEVouchers
    }`;
    if (urlString) queryParams += `&${urlString}`;
    currentURl += queryParams;
    setLoading(true);
    try {
      // getTotalRecordsCount(APIModuleConstants.pvoucher, queryParams);
      const response = await axios.get(currentURl);
      const newData = response.data.data;
      const mappedData = newData.map((voucher: any) => {
        return {
          serialNo: voucher?.seriesId ?? "-",
          voucherImage: voucher?.standard_image_1 ?? "-",

          title: voucher.Title ?? "-",
          orderId: voucher?.orderId ?? "-",
          pointSpend: voucher?.pointsSpend ?? "-",
          rewardValue: voucher.Price ?? "_",
          issuedOn: voucher?.issuedOn ? formatDate(voucher.issuedOn) : "-",
          expiryDate: voucher?.validTill ? formatDate(voucher?.validTill) : "-",
          sourceOfVouchers: voucher.source ?? "-",
          id: voucher?.transactionId ?? "-",
          merchantName: voucher?.merchantName ?? "-",
          status: voucher.status ?? "-",
          redemptionDate: voucher?.redeemedOn
            ? formatDate(voucher.redeemedOn)
            : "-",
        };
      });
      setRedeemVoucherData(mappedData);
      if (!listOFSourceOfVoucher.length) {
        const uniqueSources = Array.from(
          new Set(newData.map((voucher: any) => voucher.source))
        );
        setListOfSourceVoucher(uniqueSources);
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  // filter UI and Integration
  const [searchValue, setSearchValue] = useState("");
  const [filterState, setFilterState] = useState({
    issuanceDate: "",
    expiryDate: "",
    utilizedDate: "",
    sourceOfVoucher: "",
  });
  const onReset = () => {
    setRedeemVoucherData([]);
    setIsInitialApiCall(true);
  };
  const resetFilterState = () => {
    setFilterState({
      issuanceDate: "",
      expiryDate: "",
      utilizedDate: "",
      sourceOfVoucher: "",
    });

    setFilterStates([]);
    setFilterActive(false);
    onReset();
  };
  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const handleTransactionChange = (event: SelectChangeEvent) => {
    getAllFields(
      "source",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );

    setFilterState((prev) => ({
      ...prev,
      sourceOfVoucher: event.target.value,
    }));
  };

  const applyEVoucherFilter = () => {
    onReset();
    setOpenFilter(false);
    const anyFilterActive = Object.values(filterState).some(
      (value) => value !== ""
    );
    if (anyFilterActive) {
      setFilterActive(true);
    }
  };

  const handleSearch = () => {
    onReset();
  };
  const searchInputRef = React.useRef<HTMLInputElement>();
  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    let newURL = "";

    if (filterState.issuanceDate) {
      newURL += `issuedOn=${filterState.issuanceDate}&`;
    }
    if (filterState.expiryDate) {
      newURL += `validTill=${filterState.expiryDate}&`;
    }
    if (filterState.utilizedDate) {
      newURL += `redeemedOn=${filterState.utilizedDate}&`;
    }
    if (filterState.sourceOfVoucher) {
      newURL += `source=${filterState.sourceOfVoucher}&`;
    }
    if (searchValue) {
      newURL += `searchString=${searchValue}&`;
    }
    newURL = newURL.endsWith("&") ? newURL.slice(0, -1) : newURL;
    const apiCall = Boolean(!canHaveExistingData);
    fetchRewards(newURL, canHaveExistingData);
    setIsInitialApiCall(false);
    return newURL;
  };
  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <Dialog
        onClose={() => {
          setOpenPoints(false);
        }}
        open={openPoints}
      >
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Add or Deduct Points
            </Typography>
            {/* <IconButton onClick={()=>{setOpenPoints(false)}}>
              <CloseOutlinedIcon />
            </IconButton> */}
          </DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              borderBottom: theme.border?.smallGrey,
            }}
          >
            <Grid mt={2}>
              <FormControlLabel
                value="addPoints"
                control={
                  <Radio
                    sx={{
                      color: theme.color?.newFilterGrey,
                      "&.Mui-checked": {
                        color: theme.color?.secondary,
                      },
                    }}
                  />
                }
                label="Add Points"
              />
              <FormControlLabel
                value="deductPoints"
                control={
                  <Radio
                    sx={{
                      color: theme.color?.newFilterGrey,
                      "&.Mui-checked": {
                        color: theme.color?.secondary,
                      },
                    }}
                  />
                }
                label="Deduct Points"
              />
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableBody,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  color: theme.color?.newFilterGrey,
                }}
              >
                Point
              </Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableBody,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  color: theme.color?.newFilterGrey,
                }}
              >
                Expiry Date
              </Typography>
              <TextField
                type="date"
                id="outlined-basic"
                variant="outlined"
                size="small"
                fullWidth
                InputProps={{
                  inputProps: {
                    max: DateConstants.maxDate,
                  },
                }}
              />
            </Grid>
            <Grid mb={2}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableBody,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  color: theme.color?.newFilterGrey,
                }}
              >
                Remarks
              </Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                rows={3}
              />
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={() => {
                setOpenPoints(false);
              }}
            >
              Cancel
            </Button>
            <Button sx={{ ...buttonStyles.containedSecondary }}>Save</Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
                textTransform: "capitalize",
              }}
            >
              Filter
            </Typography>
            {/* <IconButton onClick={() => setOpenFilter(false)}> */}
            <IconButton
              onClick={() => {
                setOpenFilter(false);
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Issuance Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    value={filterState.issuanceDate}
                    onChange={(e) => {
                      getAllFields(
                        "issuance_date",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        issuanceDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Expiry Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={filterState.expiryDate}
                    onChange={(e) => {
                      getAllFields(
                        "expiry_date",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        expiryDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  {constant.domain === process.env.REACT_APP_CSA_DOMAIN
                    ? filterConstants.RedemptionDate
                    : filterConstants.UtilizationDate}
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={filterState.utilizedDate}
                    onChange={(e) => {
                      getAllFields(
                        "utilized_date",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        utilizedDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Source of Vouchers
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.sourceOfVoucher}
                      onChange={handleTransactionChange}
                    >
                      {listOFSourceOfVoucher.map((name: any) => (
                        <MenuItem value={name}>{name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={() => {
                resetFilterState();
              }}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={applyEVoucherFilter}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <Grid display={"flex"} justifyContent={"space-between"} px={4} py={3}>
        <Grid display={"flex"} gap={3} width={"100%"} justifyContent={"end"}>
          {getEVoucherPermissions("read") && (
            <SearchInput
              HelpTip={SearchToolTip.VoucherMember}
              onCallBack={handleSearch}
              ref={searchInputRef}
            />
          )}
          {getEVoucherPermissions("read") && (
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid p={2}>
        {getEVoucherPermissions("read") && (
          <InfiniteTable
            header={
              constant.domain === process.env.REACT_APP_CSA_DOMAIN
                ? MemberRedemptionColumn
                : columns
            }
            contentItems={redeemVoucherData}
            hasMoreRecords={false}
            isInitialLoading={redeemVoucherData.length === 0 && loading}
            totalRecords={redeemVoucherData.length}
            metaData={metaData}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default EvoucherTabNew;
